import styled, { css } from 'styled-components';

import {
    mediaMixin,
    token,
} from '@zillow/constellation';

export const StyledProgressStepperContainer = styled.div`
    background-color: ${token('colors.white')};
    display: flex;
    justify-content: center;
`;

export const StyledProgressStepperContent = styled.div`
    flex: 1;
    ${mediaMixin('xxl', css`
       max-width: 900px;
    `)};
`;
